import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import configureStore from './store/configureStore';
import App from './App';

// import registerServiceWorker from './registerServiceWorker';

const store = configureStore();

const rootElement = document.getElementById('root');
const app = (
    <Provider store={store}>
        <BrowserRouter>
                <App/>
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, rootElement);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js